export default "__VITE_PUBLIC_ASSET__798f0c3b__"